var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22498 3.45925L8.78038 5.71346C8.68678 6.17366 8.81158 6.64946 9.10798 7.00826C9.40438 7.36706 9.84118 7.57766 10.3092 7.57766H14.5992V8.42006L12.5946 13.0377H6.28438C6.14398 13.0377 6.01918 12.9129 6.01918 12.7725V6.65726L9.22498 3.45925ZM9.91918 0.557656L4.91938 5.55745C4.62298 5.85385 4.45918 6.25166 4.45918 6.66506V12.7725C4.45918 13.7787 5.27818 14.5977 6.28438 14.5977H12.6024C13.1562 14.5977 13.6632 14.3091 13.944 13.8411L16.0266 9.04406C16.1124 8.84906 16.1592 8.63846 16.1592 8.42006V7.57766C16.1592 6.71966 15.4572 6.01766 14.5992 6.01766H10.3092L11.0268 2.39066C11.0658 2.21906 11.0424 2.03186 10.9644 1.87586C10.785 1.52486 10.5588 1.20505 10.278 0.924255L9.91918 0.557656ZM2.11918 6.01766H0.559179V14.5977H2.11918C2.54818 14.5977 2.89918 14.2467 2.89918 13.8177V6.79766C2.89918 6.36866 2.54818 6.01766 2.11918 6.01766Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeInactive);
export default __webpack_public_path__ + "static/media/like-inactive.3dc5958dcbaaa3d306948ef5ccf7ffeb.svg";
export { ForwardRef as ReactComponent };